import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { VhQueryAutoWeb, VhEventMediator, VhAlgorithm } from 'vhautowebdb';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { forkJoin } from 'rxjs';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { LanguageService } from 'vhobjects-service/src/services';
import { AtwFrameProductsAdmin, AtwFrameFoodsAdmin, AtwFrameNewsAdmin, AtwFrameRecruitmentAdmin, AtwFrameRepeatAdmin, AtwFrameServiceAdmin, AtwFrameWebsiteAdmin } from 'vhobjects-admin';
import { FunctionService} from 'vhobjects-service/src/services';
// import { AtwFrameProductsAdmin } from '../../admin/frame-products-admin/frame-products-admin.component';
// import { AtwFrameNewsAdmin } from '../../../frame-tu-chon/frame-news/admin/frame-news-admin/frame-news-admin.component';
// import { AtwFrameFoodsAdmin } from '../../../frame-tu-chon/frame-foods/admin/frame-foods-admin/frame-foods-admin.component';
// import { AtwFrameRecruitmentAdmin } from '../../../frame-tu-chon/frame-recruitment/admin/frame-recruitment-admin/frame-recruitment-admin.component';
// import { AtwFrameServiceAdmin } from '../../../frame-tu-chon/frame-service/admin/frame-service-admin/frame-service-admin.component';
// import { AtwFrameWebsiteAdmin } from '../../../frame-tu-chon/frame-website/admin/frame-website-admin/frame-website-admin.component';
// import { AtwFrameRepeatAdmin } from '../../../frame-tu-chon/frame-repeat/admin/frame-repeat-admin/frame-repeat-admin.component';


@Component({
  selector: 'atw-frame-products-config',
  templateUrl: './frame-products-config.component.html',
  styleUrls: ['./frame-products-config.component.scss']
})
export class AtwFrameProductsConfig implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() position: any; // xác định position là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() type: any = 'page'
  @Input() staticdata: any;
  @Input() blocks_of_page?: any = [];
  @Output() changeOptionConfig = new EventEmitter<any>();
  width = 0;
  height = 0;
  public isViewAll: boolean = false;
  public isCollapsed: boolean = false;
  public currentViewAll: any = {};
  // Xử lý chỉ mở được 1 menu 1 lần
  public openMenu: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
  };
  public urlBackgroundImage = ''; // Hình ảnh nền của frame (nếu có)
  public gapSpace = 0;
  public loadComplete = false;
  public stylesField = [
    {
      title: 'dieu_chinh_vien_khung',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien_phan_tu',
      index: 2,
    },
    {
      title: 'dieu_chinh_vien_icon_trai',
      index: 3,
    },
    {
      title: 'dieu_chinh_vien_icon_phai',
      index: 4,
    },
    {
      title: 'hieu_ung',
      index: 5,
    },
    {
      title: 'nang_cao',
      index: 6,
    },
    {
      title: 'nang_cao',
      index: 7,
    }
  ];

  main_sector_for_relate: any = '';
  relatedFields: any = [];
  animation: any = {};
  effect_hover = [];
  customize = [];
  fonts: any = [];
  public bootstrapIconArrows: any = [
    {
      icon_left: 'bi bi-chevron-left',
      icon_right: 'bi bi-chevron-right',
    },
    {
      icon_left: 'bi bi-arrow-left-short',
      icon_right: 'bi bi-arrow-right-short',
    },
    {
      icon_left: 'bi bi-caret-left-fill',
      icon_right: 'bi bi-caret-right-fill',
    },
    {
      icon_left: 'bi bi-chevron-compact-left',
      icon_right: 'bi bi-chevron-compact-right',
    },
  ];

  private classUpdates = {
    "frame-products__pagination": {
      "background-color": "rgb(255, 255, 255)",
      "align-items": "center",
      "height": "50px",
      "display": "flex",
      "width": "100%",
      "margin-top": "10px",
      "justify-content": "center"
    },
    "frame-products__pagination-list-button": {
      "background-color": "transparent",
      "font-family": "Arial",
      "font-size": "16px",
      "gap": "0px",
      "display": "flex",
      "color": "green"
    },
    "frame-products__pagination-list-button--controll": {
      "align-items": "center",
      "border-style": "solid",
      "border-color": "#dddddd",
      "justify-content": "center",
      "font-size": "16px",
      "padding": "8px 16px",
      "color": "inherit",
      "display": "flex",
      "cursor": "pointer",
      "background-color": "#fff",
      "border-width": "1px",
      "font-family": "inherit"
    },
    "frame-products__pagination-list-button--page-number": {
      "font-size": "16px",
      "padding": "8px 16px",
      "display": "flex",
      "align-items": "center",
      "border-width": "1px",
      "background-color": "#fff",
      "border-style": "solid",
      "border-radius": "0px",
      "color": "#000",
      "font-family": "inherit",
      "cursor": "pointer",
      "border-color": "#ddd",
      "justify-content": "center"
    },
    "frame-products__pagination-list-button--active": {
      "color": "#fff",
      "border-width": "1px",
      "font-family": "inherit",
      "cursor": "pointer",
      "justify-content": "center",
      "border-color": "#ddd",
      "background-color": "#008000",
      "padding": "8px 16px",
      "border-style": "solid",
      "align-items": "center",
      "display": "flex",
      "font-size": "16px"
    },
    "frame-products__left-arrow--icon": {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
    },
    "frame-products__right-arrow--icon": {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
    }
  };

  private configUpdates = {
    "left_arrow_icon_shadow": {
      "property_box_shadow": {
        "spread": 1,
        "type": "outset",
        "v-offset": 1,
        "h-offset": 1,
        "color": "#ffffffff",
        "blur": 1
      },
      "is_box_shadow": false
    },
    "right_arrow_icon_shadow": {
      "property_box_shadow": {
        "spread": 1,
        "type": "outset",
        "v-offset": 1,
        "h-offset": 1,
        "color": "#ffffffff",
        "blur": 1
      },
      "is_box_shadow": false
    },
    "goToPage_pagination": {
      "border_color": "#ddd",
      "color": "green",
      "border_style": "solid",
      "content_goToPage": "Tới trang",
      "background_color": "#fff",
      "font_size": 16,
      "border_radius": 0,
      "display": false,
      "border_width": 1
    },
    "content_pagination": {
      "content_left": "Trước",
      "content_right": "Sau"
    },
    "slick_dots": {
      "height": "41px",
      "border_radius": 0,
      "width": "58px",
      "background_style": "rectangle"
    },
    "animation-selected": {
      "id": "000000"
    },
    "frame-products__pagination": {
      "hide_pagination": false
    },
    "type_display": "slide",
    "icon_pagination": {
      "icon": true,
      "color": "green",
      "font_size": 16,
      "arrow_left_icon": "bi bi-chevron-left",
      "display": false,
      "background_color": "#fff",
      "border_radius": 0,
      "border_color": "#ddd",
      "arrow_right_icon": "bi bi-chevron-right",
      "border_width": 1
    },
    "background-color": {
      "gradient_arr": [
        "rgb(0, 0, 255)",
        "rgb(255, 255, 0)"
      ],
      "background": "#8c52ff",
      "gradient_check": false,
      "value_range": 1,
      "gradient_type": "linear-gradient",
      "value_parameter": 100,
      "gradient_direction": ""
    },
    "background-color-item": {
      "gradient_arr": [
        "rgb(0, 0, 255)",
        "rgb(255, 255, 0)"
      ],
      "background": "#8c52ff",
      "gradient_check": false,
      "value_range": 1,
      "gradient_type": "linear-gradient",
      "value_parameter": 100,
      "gradient_direction": ""
    }
  }
  effect_hover_data: any = {}
  labelSectorMap: { [key: string]: string } = {
    AtwFrameProductRelate: 'san_pham',
    AtwFrameFoodsRelate: 'mon_an',
    AtwFrameHotelRelate: 'khach_san',
    AtwFrameNewsRelate: 'tin_tuc',
    AtwFrameServiceRelate: 'dich_vu',
    AtwFrameWebsiteRelate: 'website',
    AtwFrameRecruitmentRelate: 'tuyen_dung',
  }

  private mapComponent = {
    "AtwFrameProducts": AtwFrameProductsAdmin,
    // "AtwFrameHotel": AtwFrameHotelsAdmin,
    // "AtwFrameHotelFeature": AtwFrameHotelFeaturesAdmin,
    // "AtwFrameRoom": AtwFrameRoomsAdmin,
    // "AtwFrameRoomFeature": AtwFrameRoomFeaturesAdmin,
    // "AtwFrameServiceRoom": AtwFrameServiceRoomsAdmin,
    "AtwFrameRepeat": AtwFrameRepeatAdmin,
    "AtwFrameNews": AtwFrameNewsAdmin,
    "AtwFrameFoods": AtwFrameFoodsAdmin,
    // "AtwFrameAppAdmin": AtwFrameAppAdmin,
    "AtwFrameRecruitment": AtwFrameRecruitmentAdmin,
    "AtwFrameService": AtwFrameServiceAdmin,
    "AtwFrameWebsite": AtwFrameWebsiteAdmin
  }

  hasAdminComponent: boolean = false;

  private searchClassUpdates = {
    "frame-products__search": {
      display: "flex",
      "align-items": "center",
      gap: "8px",
      padding: "6px 10px",
      "background-color": "#ffffff",
      "border-style": "solid",
      "border-top-width": "1px",
      "border-bottom-width": "1px",
      "border-left-width": "1px",
      "border-right-width": "1px",
      "border-color": "#dddddd",
      "border-radius": "4px",
      "margin-bottom": "10px",
      width: "100%"
    },
    "frame-products__search--input": {
      border: "none",
      outline: "none",
      background: "transparent",
      width: "100%",
      "font-size": "14px",
      "font-family": "Arial",
      color: "#000000"
    },
    "frame-products__search--icon": {
      color: "#999999",
      "font-size": "16px"
    }
  };

  private searchConfigUpdates = {
    "frame-products__search": {
      is_show: false,
      icon: true,
      icon_name: "search",
      placeholder: "Tìm kiếm..."
    }
  };

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private nzModalService: NzModalService,
    private languageService: LanguageService,
    public vhAlgorithm: VhAlgorithm,
    public vhEventMediator: VhEventMediator,
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,
    public functionService: FunctionService
  ) {
  }

  ngOnInit(): void {
    this.mergeDefaults(this.class, this.classUpdates);
    this.mergeDefaults(this.config, this.configUpdates);

    // Search box only applies to the repeat-frame component
    if (this.objectChoosing?.component === 'AtwFrameRepeat') {
      this.mergeDefaults(this.class, this.searchClassUpdates);
      this.mergeDefaults(this.config, this.searchConfigUpdates);
      this.objectChoosing.data_type ??= 'static';
    }

    if (isPlatformBrowser(this.platformId)) {
      if (this.class && this.config) {
        this.loadComplete = true;
        // Khoảng cách giữa cột và dòng
        this.gapSpace = parseInt(
          this.class['frame-products__products']['gap'],
          10
        );
      }
      // phần này get dữ liệu json
      forkJoin([
        this.http.get('assets/fonts/fonts.json'),
        this.http.get('assets/data/effects/frame-products.json')
      ]).subscribe(([fonts, effects]: any) => {
        this.fonts = fonts;
        this.effect_hover = effects;
        this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type'])
      })
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if (isPlatformBrowser(this.platformId)) {
      this.main_sector_for_relate = this.getMainSector(this.objectChoosing.component);
      this.getRelatedFields()
    }

    if (this.main_sector_for_relate) {
      this.config.sort_type ??= 'default';
      this.config.show_current_product ??= false;
      this.config['products_item_active'] ??= {};
      this.config['products_item_active'].background_color ??= '#00eb7d';
    }

    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type'])
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }

    this.hasAdminComponent = !!this.mapComponent[this.objectChoosing?.component];
  }

  // hàm cập nhật background linear-gradient
  updateBackgroundRgb(viewMoreIndex) {
    const configMap = {
      5: {
        configKey: 'background-color',
        classKey: 'frame-products'
      },
      6: {
        configKey: 'background-color-item',
        classKey: 'frame-products__products--item'
      }
    };

    const configData = configMap[viewMoreIndex];
    if (!configData) return;

    const { configKey, classKey } = configData;
    const bgConfig = this.config[configKey];
    const gradient = bgConfig.gradient_check
      ? `linear-gradient(${bgConfig.gradient_direction}${bgConfig.gradient_arr})`
      : 'none';

    this.class[classKey]['background-image'] = gradient;
    this.updateObject();
  }

  /**
   * Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');
    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }

  /**
   * Hàm này thực hiện thêm màu gradient vào array.
   *
   */
  addGradient(value, viewMoreIndex) {
    if (!value.includes('#')) return;

    const gradient = this.config['background-color' + (viewMoreIndex == 5 ? '' : '-item')];
    gradient.gradient_arr.push(`rgba(${this.hexToRGB(value)}, ${gradient.value_range})`);
    this.updateBackgroundRgb(viewMoreIndex);
  }

  /**
   * @param index : vị trí phần tử muốn xóa
   * Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
   */
  deleteGradient(index, viewMoreIndex) {
    const configBg = this.config['background-color' + (viewMoreIndex == 5 ? '' : '-item')];
    if (configBg[`gradient_arr`].length > 1) {
      configBg[`gradient_arr`].splice(index, 1);
      this.updateBackgroundRgb(viewMoreIndex)
    }
  }

  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOption(direction, event, viewMoreIndex) {
    if (!isPlatformBrowser(this.platformId)) return;

    const configBg = this.config['background-color' + (viewMoreIndex == 5 ? '' : '-item')];
    // Gán các properties của phần tử direction vào biến trong json và cập nhật lưu vào database.
    configBg.gradient_type = direction.type;
    configBg.gradient_direction = direction.direction;
    this.class['frame-products' + (viewMoreIndex == 5 ? '' : '__products--item')]['background-image'] =
      configBg.gradient_type + '(' + configBg.gradient_direction + configBg.gradient_arr.join(',') + ')';
    this.updateObject();
  }

  openHandler(value: string): void {
    for (const key in this.openMenu) {
      if (key !== value) {
        this.openMenu[key] = false;
      }
    }
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /** Hàm thực hiện kiểm tra điều kiện 1 hướng của viền và active option đấy nếu đủ điều kiện
   *
   * @param value
   */
  checkActiveDirectionBorder(value: any) {
    if (['0px', '0'].includes(value)) return false;
    return true;
  }


  /** Hàm sẽ thực hiện disable các option khi lựa chọn tải ảnh nền cho frame
   *
   * @param valueItem
   * @returns
   */
  checkDisableUploadImage(valueItem: any) {
    if (this.class['frame-products'].is_upload_image === valueItem)
      return false;
    return true;
  }


  // //Hàm update class
  updateClass() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
      })
      .then((bool: any) => {

      });
  }

  // //Hàm update class
  updateConfig() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_config']: this.config,
      })
      .then((bool: any) => {

      });
  }

  updateTypeDisplay() {
    this.updateConfig();
    this.functionService.updateDimension(this.objectChoosing)
  }

  /**
   * Hàm update object vào database.
   */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {
        // console.log('updateObject', bool);
        if (this.objectChoosing.is_child_banner || this.objectChoosing.is_child_tabs || this.objectChoosing.is_child_collapse) {
          // nếu là frame-products con của banner thì bắn sự kiện frame-banner set lại z-index frame-products con
          // và bắn ra sự kiện choose-selected-ruler để set lại objectChoosing vì frame-banner, collapse, tabs không có vhObjectSelected nên sẽ ko tự bắn sự kiện được
          this.vhEventMediator.notifyOnConfigChanged({
            status: 'config-changed',
            code: this.objectChoosing.id_object,
          });
        }
      })
  }

  /**
  *Hàm update class vào database, và gửi cập nhật width, height cho object-selected
  */
  updateClassAndWidthHeight() {
    if (isPlatformBrowser(this.platformId)) {
      this.width = document.getElementById(this.objectChoosing._id).clientWidth;
      this.height = document.getElementById(this.objectChoosing._id).clientHeight;
      this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
      this.updateClass();
      // this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      //   .then((bool: any) => {

      //   })
    }
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['frame-products']['width'] = event.width + 'px';
    if (event.height) this.class['frame-products']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.updateClassAndWidthHeight()
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.stylesField[4])
  }

  openModalEdit() {
    const modal: NzModalRef = this.nzModalService.create({
      nzTitle: this.languageService.translate('chinh_sua_noi_dung'),
      nzWidth: '80%',
      nzContent: this.mapComponent[this.objectChoosing.component],
      nzComponentParams: {
        data: {
          ...this.objectChoosing,
          blocks_of_page: this.blocks_of_page,
        },
        type: 'page'
      },
      nzFooter: null,
    });
    modal.afterClose.subscribe(result => {
      // this.vhEventMediator.notifyOnConfigChanged({
      //   status: 'config-changed',
      //   code: this.objectChoosing._id,
      // });
    });
  }

  /**
   * Kiểu nút slide
   * @param event
   */
  handleSetDotsStyle(event) {
    switch (event) {
      case 'circle':
        this.class['frame-products__pagination-list-button--controll'][
          'border-radius'
        ] = 50 + 'px';
        this.class[
          'frame-products__pagination-list-button--page-number'
        ]['border-radius'] = 50 + 'px';
        this.class['frame-products__pagination-list-button--active'][
          'border-radius'
        ] = 50 + 'px';
        this.config[`slick_dots`]['height'] =
          this.config[`slick_dots`]['width'];
        break;
      case 'rectangle':
        this.class['frame-products__pagination-list-button--controll'][
          'border-radius'
        ] = 0 + '%';
        this.class[
          'frame-products__pagination-list-button--page-number'
        ]['border-radius'] = 0 + '%';
        this.class['frame-products__pagination-list-button--active'][
          'border-radius'
        ] = 0 + '%';
        break;
    }

    this.updateConfig();
    this.updateClass();
  }

  /**
 * Kích thước cho nút next/prev
 *  @param event
 *  @param type nút next hay prev
 */
  handleSetButtonSize(event) {
    var style = this.config[`slick_dots`]['background_style'];

    this.config[`slick_dots`]['width'] = event + 'px';
    this.config['slick_dots']['height'] = event + 'px';
    this.class['frame-products__pagination-list-button--controll'][
      'border-radius'
    ] = 50 + 'px';
    this.class['frame-products__pagination-list-button--page-number'][
      'border-radius'
    ] = 50 + 'px';
    this.class['frame-products__pagination-list-button--active'][
      'border-radius'
    ] = 50 + 'px';
  }

  /*--------- Thay đổi mũi tên điều hướng trang -------------------*/
  onChangeArrows(arrows) {
    this.config.icon_pagination.arrow_left_icon = arrows.icon_left;
    this.config.icon_pagination.arrow_right_icon = arrows.icon_right;
    this.updateConfig();
  }

  getMainSector(component: any): string {
    const sectorMap: { [key: string]: string } = {
      AtwFrameProductRelate: 'ecommerce',
      AtwFrameFoodsRelate: 'food',
      AtwFrameHotelRelate: 'hotel',
      AtwFrameNewsRelate: 'news',
      AtwFrameServiceRelate: 'service',
      AtwFrameWebsiteRelate: 'website',
      AtwFrameRecruitmentRelate: 'recruitment',
    };

    return sectorMap[component] || '';
  }

  getRelatedFields() {
    const defaultFieldsBySector: {
      [key: string]: { label: string, value: { field: string, type: string, device_dependent: boolean, language_dependent: boolean } }[]
    } = {
      ecommerce: [
        { label: 'Danh mục', value: { field: 'id_categorys', type: 'array', device_dependent: false, language_dependent: false } },
        { label: 'Tên sản phẩm', value: { field: 'name', type: 'string', device_dependent: false, language_dependent: true } },
        { label: 'Thương hiệu', value: { field: 'brand', type: 'string', device_dependent: false, language_dependent: false } },
        { label: 'Mô tả', value: { field: 'webapp_description', type: 'string', device_dependent: true, language_dependent: true } },
        { label: 'Mô tả ngắn', value: { field: 'webapp_sort_description', type: 'string', device_dependent: true, language_dependent: true } }
      ],
      food: [
        { label: 'Danh mục', value: { field: 'id_categorys', type: 'array', device_dependent: false, language_dependent: false } },
        { label: 'Tên món', value: { field: 'name', type: 'string', device_dependent: false, language_dependent: true } },
        { label: 'Mô tả chi tiết', value: { field: 'webapp_description', type: 'string', device_dependent: true, language_dependent: true } },
        { label: 'Mô tả ngắn', value: { field: 'webapp_sort_description', type: 'string', device_dependent: true, language_dependent: true } }
      ],
      hotel: [
        //chưa có khi làm khung hotel phải thêm các mục liên quan cần có ở đây
      ],
      news: [
        { label: 'Danh mục', value: { field: 'id_categorys', type: 'array', device_dependent: false, language_dependent: false } },
        { label: 'Tiêu đề tin tức', value: { field: 'title', type: 'string', device_dependent: false, language_dependent: true } },
        { label: 'Nội dung tin tức', value: { field: 'content', type: 'string', device_dependent: true, language_dependent: true } },
        { label: 'Mô tả ngắn tin tức', value: { field: 'description', type: 'string', device_dependent: true, language_dependent: true } }
      ],
      service: [
        { label: 'Danh mục', value: { field: 'id_categorys', type: 'array', device_dependent: false, language_dependent: false } },
        { label: 'Tên dịch vụ', value: { field: 'name', type: 'string', device_dependent: false, language_dependent: true } },
        { label: 'Mô tả chi tiết', value: { field: 'webapp_description', type: 'string', device_dependent: true, language_dependent: true } },
        { label: 'Mô tả ngắn', value: { field: 'webapp_sort_description', type: 'string', device_dependent: true, language_dependent: true } }
      ],
      website: [
        { label: 'Danh mục', value: { field: 'id_categorys', type: 'array', device_dependent: false, language_dependent: false } },
        { label: 'Tên website', value: { field: 'name', type: 'string', device_dependent: false, language_dependent: true } },
        { label: 'Mô tả chi tiết', value: { field: 'webapp_description', type: 'string', device_dependent: true, language_dependent: true } },
        { label: 'Mô tả chi tiết', value: { field: 'webapp_description', type: 'string', device_dependent: true, language_dependent: true } },
        { label: 'Phiên bản', value: { field: 'version', type: 'string', device_dependent: false, language_dependent: false } },
        { label: 'Đường dẫn tham khảo', value: { field: 'link_website_demo', type: 'string', device_dependent: false, language_dependent: false } }
      ]
    };

    this.relatedFields = defaultFieldsBySector[this.main_sector_for_relate] || [];
    this.getNewFileds();
  }

  compareRelatedField(o1: any, o2: any): boolean {
    if (!o1 || !o2) return false;
    return o1.field === o2.field && o1.type === o2.type;
  }

  getNewFileds() {
    this.vhQueryAutoWeb.getNewFields_byFields({ id_main_sector: { $eq: this.main_sector_for_relate } }).then((newfields: any[]) => {
      let sortedFields = this.vhAlgorithm.sortStringbyASC(newfields, 'name');

      const dynamicFields = sortedFields.map(field => ({
        label: field.field_lable || field.name,
        value: { field: field.field_custom, type: 'string', device_dependent: false, language_dependent: true }
      }));

      this.relatedFields = [
        ...this.relatedFields,
        ...dynamicFields
      ];
    });
  }

  private mergeDefaults(target: any, defaults: any) {
    for (const key in defaults) {
      if (!target.hasOwnProperty(key)) {
        target[key] = defaults[key];
      } else {
        for (const key2 in defaults[key]) {
          if (!target[key].hasOwnProperty(key2)) {
            target[key][key2] = defaults[key][key2];
          }
        }
      }
    }
  }

  async onChangeDataType() {
    const newType = this.objectChoosing.data_type;
    this.staticdata ??= {};
    this.staticdata.data_list ??= [];

    if (newType === 'dynamic') {
      // Case: Switching to Basics Collection ('dynamic')
      if (this.staticdata.data_list.length > 0) {
        const response: any = await this.vhQueryAutoWeb.getDocs_byFields('basics', { id_object: { $eq: this.objectChoosing._id } });
        
        if (response.vcode === 0 && response.data?.length > 0) {
          const existingDoc = response.data[0];
          const mergedList = [...(existingDoc.data_list || []), ...this.staticdata.data_list];
          await this.vhQueryAutoWeb.updateDoc('basics', existingDoc._id, { data_list: mergedList });
        } else {
          await this.vhQueryAutoWeb.addDoc('basics', {
            id_object: this.objectChoosing._id,
            data_list: this.staticdata.data_list
          });
        }
        
        // Clear data_list in staticdata after migrating
        this.staticdata.data_list = [];
      }
    } else if (newType === 'static') {
      // Case: Switching to Staticdata ('static')
      const response: any = await this.vhQueryAutoWeb.getDocs_byFields('basics', { id_object: { $eq: this.objectChoosing._id } });
      
      if (response.vcode === 0 && response.data?.length > 0) {
        const doc = response.data[0];
        const basicsDataList = doc.data_list || [];
        
        // Merge data into staticdata
        this.staticdata.data_list = [...this.staticdata.data_list, ...basicsDataList];
        
        // Remove the document in basics collection
        try {
          await this.vhQueryAutoWeb.deleteDoc('basics', doc._id);
        } catch (error) {
          console.error('Failed to delete basics doc, fallback to clearing data_list', error);
          await this.vhQueryAutoWeb.updateDoc('basics', doc._id, { data_list: [] });
        }
      }
    }

    // Update object with the new data_type and modified staticdata
    await this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
      data_type: newType,
      staticdata: this.staticdata
    }).then(() => {
      this.vhEventMediator.notifyOnConfigChanged({
        status: 'config-changed',
        code: this.objectChoosing._id,
      });
    });
  }
}